import { RouteConfig } from "vue-router";
import { IMenu, IMenuItem } from "../menus/imenu";
import { ISideMenuItem } from "../menus/isidemenu";
import { AppModule } from "./app.module";
import { AppModuleComponent } from "./app.module.component";

export class AppConfiguration {
  private _modules: AppModule[] = [];
  private _navigationNenu: IMenu = { menus: [] };
  private _userMenu: IMenu = { menus: [] };

  addModule(module: AppModule) {
    this._modules.push(module);
  }

  setNavigationMenu(menus: IMenuItem[]): void {
    this._navigationNenu.menus = menus;
  }

  editMainNavigationMenuTitle(reference: string, title: string): void {
    const m = this._navigationNenu.menus.find(s => s.reference == reference);
    if (m != null) {
      m.title = title;
    }
  }

  editSubNavigationMenuTitle(
    referenceMain: string,
    referenceSub: string,
    title: string
  ): void {
    const m = this._navigationNenu.menus.find(
      s => s.reference == referenceMain
    );
    if (m != null) {
      const c = m.subMenus?.find(s => s.reference == referenceSub);
      if (c != null) {
        c.title = title;
      }
    }
  }

  setUserMenu(menus: IMenuItem[]): void {
    this._userMenu.menus = menus;
  }

  private getModules(): AppModule[] {
    return this._modules.sort((a, b) => a.Order - b.Order);
  }

  generateRoutes(): RouteConfig[] {
    let routes: RouteConfig[] = [];
    this.getModules().forEach((module: AppModule) => {
      if (module.enabled) {
        if (module.name.toUpperCase() == "CORE") {
          routes = routes.concat(module.Routes);
        } else {
          routes[0].children = routes[0].children?.concat(module.Routes);
        }
      }
    });
    return routes;
  }

  getMenu(module: string, name: string): ISideMenuItem[] {
    const m = this._modules.find(
      (m: AppModule) => m.name.toUpperCase() == module.toUpperCase()
    );
    return m ? m.getMenu(name) : [];
  }

  getComponents(): AppModuleComponent[] {
    let components: AppModuleComponent[] = [];
    this.getModules().forEach((module: AppModule) => {
      if (module.enabled) {
        components = components.concat(module.Components);
      }
    });
    return components;
  }

  changeRoute(module: string, route: string, data: any): void {
    // Search up to 2 levels
    const m = this._modules.find(
      (m: AppModule) => m.name.toUpperCase() == module.toUpperCase()
    );
    if (m) {
      m.Routes.forEach(r => {
        if (r.name?.toUpperCase() == route.toUpperCase()) {
          Object.assign(r, { component: data });
        } else if (r.children && r.children.length > 0) {
          r.children.forEach(s => {
            if (s.name?.toUpperCase() == route.toUpperCase()) {
              Object.assign(s, { component: data });
            }
          });
        }
      });
    }
  }

  changeComponent(module: string, name: string, data: any): void {
    const m = this._modules.find(
      (m: AppModule) => m.name.toUpperCase() == module.toUpperCase()
    );
    if (m) {
      const c = m.Components.find(
        comp => comp.name.toUpperCase() == name.toUpperCase()
      );
      if (c) {
        c.setComponent(data);
      }
    }
  }

  isModuleActive(module: string): boolean {
    return (
      this._modules.find(
        m => m.name.toUpperCase() == module.toUpperCase() && m.enabled
      ) != null
    );
  }

  disableModule(name: string): void {
    const m = this._modules.find(
      m => m.name.toUpperCase() == name.toUpperCase()
    );
    if (m) {
      m.disableMenu();
    }
  }

  getNavigationMenu(): IMenu {
    return this._navigationNenu;
  }

  getUserMenu(): IMenu {
    return this._userMenu;
  }

  appendNavigationSubMenu(
    module: string,
    menuReference: string,
    link: ISideMenuItem,
    data: any
  ): void {
    const m = this.getModules().find(
      s => s.name.toUpperCase() == module.toUpperCase()
    );
    if (m != null) {
      m.addMenuLink(menuReference, link, data);
    }
  }

  removeNavigationSubMenus(
    module: string,
    menuReference: string,
    titleLink: string
  ): void {
    const m = this.getModules().find(
      s => s.name.toUpperCase() == module.toUpperCase()
    );
    if (m != null) {
      m.removeMenuLink(menuReference, titleLink);
    }
  }
}
